import { BomDto } from "src/dtos/bom/BomDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { formatDate } from "src/utils/string/stringUtil";
import { MST1020_R01_DEFAULT_MATERIAL_INTYPE } from "./ExcelDefinition_MST1020_R01";



export interface MST1020_R01HeaderDto extends ItemDto{
	hasChildYn: string;
}

export const defaultMST1020_R01HeaderDto: MST1020_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	itemCd: '',
	itemNm: '',
	modelNo: '',
	itemSpec: '',
	itemUnit: '',
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	stockQty: 0,
	itemCost: 0,
	workCost: 0,
	stockAmount: 0,
	locationCd: '',
	locationNm: '',
	locationCd2: '',
	purQty: 0,
	packQty: 0,
	salQty: 0,
	itemImage: '',
	itemImage2: '',
	customCd: '',
	customNm: '',
	customItemcd: '',
	equipmentCd: '',
	equipmentNm: '',
	prodStockType: 'I',
	inspectYn: 'Y',
	remark: '',

	hasChildYn: '',

	inserted: false,
	isModified: false,
}

/**
 * BOM 관리 데이터를 위한 내부 확장 인터페이스
 * inserted: 새로 생성된 데이터 여부
 * isModified: 수정된 데이터 여부
 * isDeleted: 삭제된 데이터 여부
 */
export interface MST1020_R01_BomDto extends BomDto{
	inserted: boolean;      // 신규 행 여부
	isModified: boolean;    // 수정 여부
	isDeleted?: boolean;     // 삭제 여부
	applyBeginDt?: string;  // 적용 시작일시
	applyEndDt?: string;    // 적용 종료일시
	locationCd?: string;    // PIC: 자품목 기본 로케이션 코드
	locationNm?: string;    // PIC: 자품목 기본 로케이션명 (표시용)
}

/**
 * BOM 관리의 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultBomData: MST1020_R01_BomDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '1', // 기본값을 '1'로 설정
	prntItemQty: 1,
	prntItemUnit: 'EA',
	childItemUsage: 0,
	childItemUnit: 'EA',
	fixLossqty: 0,
	// 화면 기본행과 Excel 예시·안내표가 동일한 자재공급방법 기본 코드를 사용한다.
	materialIntype: MST1020_R01_DEFAULT_MATERIAL_INTYPE, // 기본값: 구매
	lossPercent: 0,
	remark: '',

	applyBeginDt: formatDate(new Date()),
	applyEndDt: '9999-12-31',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: '',
};
